// extracted by mini-css-extract-plugin
export default {"footerMenu":"QuickActionsPanel_footerMenu__dGve7","iconButton":"QuickActionsPanel_iconButton__YIRTw"};